import React, { useState, useEffect, useRef } from 'react';
import Icon from 'react-icons-kit';
import { ic_south_east } from 'react-icons-kit/md/ic_south_east'

import './app.css';
import { sanitizeTemplate } from '../../Utils/helper';

const DraggableItem = ({ content, updatePosition, setSelectedItem, isSelected, items, isCollisionEnabled, parentRef, contentType }) => {
  const [position, setPosition] = useState({ top: content.top, left: content.left });
  const [size, setSize] = useState({ width: content.name === contentType[6] ? 150 : content.width,
    height: content.name === contentType[6] ? 150 : content.height });
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const itemRef = useRef(null);

  // const isColliding = (newPosition, newSize) => {
  //   return items.some(item => {
  //     if (item.id === content.id) return false;
  //     const other = {
  //       left: item.left,
  //       top: item.top,
  //       right: item.left + item.width,
  //       bottom: item.top + item.height
  //     };
  //     const current = {
  //       left: newPosition.left,
  //       top: newPosition.top,
  //       right: newPosition.left + newSize.width,
  //       bottom: newPosition.top + newSize.height
  //     };
  //     return (
  //       current.left < other.right &&
  //       current.right > other.left &&
  //       current.top < other.bottom &&
  //       current.bottom > other.top
  //     );
  //   });
  // };

  useEffect(()=>{
    if(content.name === contentType[6]){
      setIsResizing(false)
    }
  },[])
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        const parentRect = parentRef.current.getBoundingClientRect();
        const parentWidth = parentRef.current.offsetWidth;   // actual rendered width
        const parentHeight = parentRef.current.offsetHeight; // actual rendered height
    
        const newLeft = e.clientX - parentRect.left - offset.x;
        const newTop = e.clientY - parentRect.top - offset.y;
    
        const clampedLeft = Math.max(0, Math.min(newLeft, parentWidth - size.width));
        const clampedTop = Math.max(0, Math.min(newTop, parentHeight - size.height));
        const newPosition = { left: clampedLeft, top: clampedTop };
        setPosition(newPosition);
        updatePosition(content.id, { left: clampedLeft, top: clampedTop });
      }
    
      if (isResizing) {
        const parentWidth = parentRef.current.offsetWidth;
        const parentHeight = parentRef.current.offsetHeight;
        const itemRect = itemRef.current.getBoundingClientRect();
    
        const newWidth = size.width + (e.clientX - itemRect.right);
        const newHeight = size.height + (e.clientY - itemRect.bottom);
    
        const maxWidth = parentWidth - position.left;
        const maxHeight = parentHeight - position.top;
    
        const clampedWidth = Math.max(50, Math.min(newWidth, maxWidth));
        const clampedHeight = Math.max(30, Math.min(newHeight, maxHeight));
    
        setSize({ width: clampedWidth, height: clampedHeight });
        updatePosition(content.id, { width: clampedWidth, height: clampedHeight });
      }
    };;

    const handleMouseUp = () => {
      setIsDragging(false);
      setIsResizing(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, isResizing, position, size, offset, isCollisionEnabled, parentRef]);

  const handleMouseDown = (e) => {
    e.preventDefault()
    const rect = itemRef.current.getBoundingClientRect();
    const parentRect = parentRef.current.getBoundingClientRect();
    setOffset({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    });
    setIsDragging(true);
    setSelectedItem(content.id);
  };

  const handleResizeMouseDown = (e) => {
    e.stopPropagation();
    if(content.name===contentType[6]){
      setIsResizing(false)
    }
    else{
    setIsResizing(true);
    }
  };

  return (
    <div
      ref={itemRef}
      className={`draggable-item ${isSelected ? 'selected' : ''}`}
      onMouseDown={handleMouseDown}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        width: `${size.width}px`,
        height: `${size.height}px`,
        position: 'absolute',
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: sanitizeTemplate(content.content) }} />
      {isSelected &&content.name!==contentType[6] ? <div className="resize-handle" onMouseDown={handleResizeMouseDown}><Icon icon={ic_south_east} size={'0.7rem'} style={{ color: 'var(--gray-700)' }} /></div> : null}
    </div>
  );
};

export default DraggableItem;
